import { Directive, HostListener, Input } from '@angular/core';
import { IProduct } from '@models/product';
import { MenuService } from '@services/menu.service';

@Directive({
  selector: '[appNavigateToProductPage]'
})
export class NavigateToProductPageDirective {
  @Input('appNavigateToProductPage') product: IProduct;

  @HostListener('click') onClick() {
    this.navigateToProductPage();
  }
  constructor(private readonly menu: MenuService) {}

  public navigateToProductPage() {
    this.menu.navigateToComponent(null, this.product);
  }
}
